"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForkRef = void 0;
var react_1 = require("react");
var utils_1 = require("./utils");
exports.useForkRef = function (refA, refB) {
    return react_1.useMemo(function () {
        if (refA == null && refB == null) {
            return null;
        }
        return function (refValue) {
            utils_1.setRef(refA, refValue);
            utils_1.setRef(refB, refValue);
        };
    }, [refA, refB]);
};
